// -----------------------------------------------------------------------------------------------------------------------
// This is a temporary storage used for the variables shared that should not be persisted on the local storage
// -----------------------------------------------------------------------------------------------------------------------

// Zustand import
import { create } from 'zustand';
import usePersistentStore from '../persistent/persistentStore';
import Grid from '../../../Geodata/grid';

export type LoadingMessage = {
    title: string;
    description?: string;

    progress?: number; // 0..100
    cancellable?: boolean;
    onCancel?: () => void;
    loadingMessageId?: string;
};

// ----------- UiSessionState ------------------------------------------------------------

type UiSessionState = {
    // Values
    activeSpIndex: number;
    loadingMessage: LoadingMessage | null;

    // Setters
    setActiveSpIndex: (n: number) => void;
    setLoadingMessage: (message: LoadingMessage | null) => void;
};

// ----------- Create ------------------------------------------------------------

/**
 * @deprecated
 * Use viewerStore or loadingStore for tmp data instead
 */
export const useSessionStore = create<UiSessionState>((set) => ({
    activeSpIndex: Grid.firstActiveID,
    setActiveSpIndex: (n) => set({ activeSpIndex: n }),
    loadingMessage: null,
    setLoadingMessage: (message) => set({ loadingMessage: message }),
}));

// ----------- Helpers ------------------------------------------------------------

// SpIndex helpers
export function setActiveSpIndex(idx: number) {
    const [x, y, z] = Grid.indexToXYZ(idx);
    usePersistentStore.getState().setSimulationItems({ x, y, z });
    useSessionStore.getState().setActiveSpIndex(idx);
}

export function setActiveSpXYZ(x: number, y: number, z: number) {
    usePersistentStore.getState().setSimulationItems({ x, y, z });
    const idx = Grid.xyzToIndex(x, y, z);
    useSessionStore.getState().setActiveSpIndex(idx);
}

export function syncSessionFromXYZ() {
    const L = usePersistentStore.getState().getActiveLayerState?.();
    if (!L) {
        useSessionStore.getState().setActiveSpIndex(Grid.firstActiveID);
        return;
    }
    const { x, y, z } = L.simulationItems;
    useSessionStore.getState().setActiveSpIndex(Grid.xyzToIndex(x, y, z));
}
